<template>
  <b-card
    border-variant="secondary"
    style="background: #fbfcfe; border: 1px dashed #ced4da !important"
  >
    <b-row>
      <b-col
        cols="12"
        class="d-flex justify-content-between align-items-center"
      >
        <div
          class="d-flex justify-content-between align-items-center"
          style="gap: 16px; width: 100%"
        >
          <div
            class="d-flex justify-content-between align-items-center"
            style="gap: 1px"
          >
            <h4 class="mb-0">Group</h4>
            <span
              class="d-flex justify-content-center align-items-center"
              style="
                width: 20px;
                height: 20px;
                display: inline-block;
                border-radius: 100%;
                background: #eef2f7;
                font-size: 12px;
              "
              >{{ order }}</span
            >
          </div>
          <div>
            <b-button
              @click="emitAddCondition"
              variant="outline-secondary"
              class="mr-1"
              style="padding: 9px"
            >
              <feather-icon icon="PlusIcon" />
              Add Condition
            </b-button>
            <b-button
              @click="emitRemove(group.id)"
              variant="outline-danger"
              style="padding: 6px"
            >
              <feather-icon icon="TrashIcon" size="20" />
            </b-button>
          </div>
        </div>
      </b-col>

      <div class="d-flex align-items-center" style="gap: 10px">
        <p class="m-0 ml-1">Combine conditions in this group using</p>
        <div class="d-flex align-items-center">
          <button
            style="
              border-radius: 4px 0 0 4px;
              border: 1px solid #6c757d;
              background: white;
              color: #6c757d;
            "
            :class="{ 'active-logic': !group.logic }"
            @click="emitToggleConditionLogic(false, group.id)"
          >
            AND
          </button>
          <button
            style="
              border-radius: 0 4px 4px 0;
              border: 1px solid #6c757d;
              background: white;
              color: #6c757d;
            "
            :class="{ 'active-logic': group.logic }"
            @click="emitToggleConditionLogic(true, group.id)"
          >
            OR
          </button>
        </div>
      </div>

      <b-col cols="12">
        <div
          v-for="condition in group.conditions"
          :key="condition.id"
          class="mt-1"
        >
          <div class="d-flex align-items-end" style="gap: 10px">
            <b-row style="width: 100%">
              <b-col cols="4">
                <label class="font-weight-bold">Field</label>
                <v-select
                  :value="condition.field"
                  :options="fields"
                  :reduce="(val) => val.value"
                  :clearable="false"
                  @input="
                    (val) => {
                      emitUpdateField(val, group.id, condition.id);
                      if (
                        (val === 'hasDepositLimit' || val === 'isVerified') &&
                        condition.operator !== '='
                      )
                        emitUpdateOperator('=', group.id, condition.id);
                    }
                  "
                  class="w-100"
                />
              </b-col>
              <b-col cols="4">
                <label class="font-weight-bold">Operator</label>
                <v-select
                  :value="condition.operator"
                  :options="operators"
                  :reduce="(val) => val.value"
                  :clearable="false"
                  :disabled="
                    condition.field === 'hasDepositLimit' ||
                    condition.field === 'isVerified'
                  "
                  @input="
                    (val) => emitUpdateOperator(val, group.id, condition.id)
                  "
                  class="w-100"
                />
              </b-col>
              <b-col v-if="condition.operator" cols="4">
                <label class="font-weight-bold">Value</label>

                <v-select
                  v-if="
                    condition.field === 'hasDepositLimit' ||
                    condition.field === 'isVerified'
                  "
                  :value="condition.value"
                  :options="YesNoOption"
                  :reduce="(val) => val.value"
                  :clearable="false"
                  @input="(val) => emitUpdateValue(val, group.id, condition.id)"
                  class="w-100"
                />
                <b-form-input
                  v-else
                  v-model="condition.value"
                  class="w-100"
                  placeholder="Enter value"
                />
              </b-col>
            </b-row>
            <b-button
              variant="outline-danger"
              style="padding: 6px; height: 34px"
              @click="emitRemove(group.id, condition.id)"
            >
              <feather-icon icon="TrashIcon" size="20" />
            </b-button>
          </div>
          <!-- </b-card> -->
        </div>
      </b-col>
      <p class="m-0 mt-1 ml-1">
        Groups will be combined using the selector above ( <span class="font-weight-bold">AND</span> or  <span class="font-weight-bold">OR</span> ).
      </p>
    </b-row>
  </b-card>
</template>

<script>
import {
  BBadge,
  BButton,
  BCard,
  BCol,
  BRow,
  BCardBody,
  BFormInput,
  BFormTextarea,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormGroup,
  BImg,
  BFormCheckboxGroup,
  BFormSelect,
  BCollapse,
} from "bootstrap-vue";
import vSelect from "vue-select";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import { arrayProp, numberProp, objectProp } from "@/helpers/props";
import { VBToggle } from "bootstrap-vue";
import { YesNoOption } from "@/@core/utils/enum/user";

export default {
  props: {
    group: objectProp(),
    groupLength: numberProp(),
    fields: arrayProp(),
    operators: arrayProp(),
    order: numberProp(),
  },
  components: {
    BBadge,
    BButton,
    BCard,
    BRow,
    BCol,
    vSelect,
    BCardBody,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormGroup,
    BImg,
    BFormCheckboxGroup,
    BFormSelect,
    FeatherIcon,
    BCollapse,
  },
  directives: {
    "b-toggle": VBToggle,
  },
  watch: {},
  methods: {
    emitRemove(groupId, conditionId) {
      this.$emit("removeCondition", groupId, conditionId);
    },
    emitAddCondition() {
      this.$emit("addCondition", this.group.id);
    },
    emitUpdateField(val, groupId, conditionId) {
      this.$emit("updateField", val, groupId, conditionId);
    },
    emitUpdateOperator(val, groupId, conditionId) {
      this.$emit("updateOperator", val, groupId, conditionId);
    },
    emitToggleConditionLogic(val, groupId, conditionId) {
      this.$emit("toggleConditionLogic", val, groupId, conditionId);
    },
    emitUpdateValue(val, groupId, conditionId) {
      this.$emit("updateValue", val, groupId, conditionId);
    },
  },
  setup() {
    return {
      YesNoOption,
    };
  },
};
</script>

<style lang="scss" scoped>
.active-logic {
  background: #6c757d !important;
  color: white !important;
}
</style>